export default function TS_NodeJS() {
  return (
    <div>
      <h1>TS with Node.js</h1>
      <p>This is the TS with Node.js page.</p>
    </div>
  );
}